import { ShortcutGroup } from "modules/shortcuts/models";
import React, { MouseEvent } from "react";
import DropZone from "./dropZone";
import { useDragReorder } from "modules/common/hooks/useDragReorder";
import DraggableNameContainer from "./draggableNameContainer";

interface IDraggableShortcutGroupsFormatProps {
    shortcutGroups: ShortcutGroup[];
    shortcutGroupDragged: number;
    onDrop: (itemToMoveIdx: number, moveToItemId?: string, moveToitemIdx?: number) => void;
    onMouseMove: (e: MouseEvent, isDragging: boolean) => void;
}

const DraggableShortcutGroupsFormat: React.FC<IDraggableShortcutGroupsFormatProps> = ({
    shortcutGroups,
    shortcutGroupDragged,
    onDrop,
    onMouseMove
}) => {
    const onItemDrop = (id?: string, idx?: number) => {
        onDrop(shortcutGroupDragged!, id, idx);
    }
    
    const { mousePos, dropIdx } = useDragReorder({
        enabled: true,
        items: shortcutGroups,
        draggedIdx: shortcutGroupDragged,
        onDrop: onItemDrop,
        dropZoneClassName: "drop-zone",
        mouseHandlerComponentClassName: "shortcut-group-list"
    });

    return <React.Fragment>
        <DropZone isHidden={shortcutGroupDragged === null || dropIdx !== 0}/>
        {
            shortcutGroups.map((sg, idx) => {
                const isFloating = shortcutGroupDragged === idx;

                return <React.Fragment key={sg.id}>
                    <DraggableNameContainer 
                        divClassName="shortcut-group-name-div"
                        floatingClassName={isFloating ? "shortcuts-floating" : ""} 
                        divStyle={{
                            left: isFloating ? mousePos.left + 15 : 'initial',
                            top: isFloating ? mousePos.y - 93 : 'initial',
                            width: isFloating ? '100%' : 'initial',
                        }} 
                        name={sg.name} 
                        nameClassName="shortcut-group-name"
                        iconClassName="shortcuts-drag-indicator"
                        onMouseMove={e => onMouseMove(e, shortcutGroupDragged !== null)}
                    />
                    {shortcutGroupDragged !== idx && <DropZone isHidden={shortcutGroupDragged === null || dropIdx !== idx + 1} />}
                </React.Fragment>
            })
        }
    </React.Fragment>;
};

export default DraggableShortcutGroupsFormat;
